import React from "react";
/* Replace path below with where you put the scanned image */
import scanImg from "../../assets/Car Image.png";

/**
 * GatePassFromImage
 * - props.data: object to override default sample values
 *
 * Example usage:
 * <GatePassFromImage data={{ gateNo: 'KA-GP-07377', custName: 'M Bilal' }} />
 */
const GatePassFromImage = ({ data = {} }) => {
  // default values (from the scanned sample)
  const defaultData = {
    gateNo: "KA-GP-07377",
    issuedDate: "JULY 28, 2025 8:18 PM",

    custName: "M BILAL",
    custEmail: "bilal@example.com",
    custPhone: "058 997 8185",
    handOverTo: "Customer",
    recoveryName: "-",
    recoveryPhone: "-",
    invNo: "21565",
    vinNo: "623487",
    make: "DODGE",
    model: "CHALLENGER",
    year: "2021",
    color: "BLACK",
    auctionDate: "JULY 28, 2025",
    hammer: 25000,
    total: 27250,
    paymentRef: "INV-784512",
    verifyUrl: "https://khataljazeera.com/verify?no=KA-GP-07377",
  };

  const d = { ...defaultData, ...data };

  // helper for currency
  const AED = (v) =>
    new Intl.NumberFormat("en-AE", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    }).format(v);

  return (
    <div className="min-h-screen bg-gray-100 p-6 font-poppins">
      <style jsx>{`
        @media print {
          @page {
            size: A5 landscape;
            margin: 0.25in;
          }
          .page {
            width: 5.85in !important;
            min-height: 4.13in !important;
            max-width: none !important;
            margin: 0 !important;
            box-shadow: none !important;
            border: none !important;
          }
        }
      `}</style>
      {/* Toolbar / actions */}
      <div className="no-print flex justify-end mb-4 gap-2">
        <button
          onClick={() => window.print()}
          className="px-3 py-2 rounded border bg-white text-sm hover:bg-gray-50"
        >
          Print / Save as PDF
        </button>
      </div>

      {/* Horizontal A5 paper container */}
      <div className="mx-auto max-w-[595px]">
        <div className="page bg-white border border-gray-200 rounded shadow overflow-hidden min-h-[420px]">
          {/* Header */}
          <div className="p-4 border-b border-gray-200">
            {/* Top section with logo and main title */}
            <div className="flex items-center justify-center mb-3">
              <div className="flex items-center gap-4">
                {/* Circular logo with car icon */}
                <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center">
                  <div className="text-white text-center">
                    <div className="text-xs font-bold leading-tight">
                     Sky Auto Trade
                    </div>
                    <div className="text-xs font-bold leading-tight">
                      CARS AUCTION
                    </div>
                  </div>
                </div>

                {/* Main title */}
                <h1 className="text-xl font-bold text-gray-800 text-center">
                  SkyAutoTrade CARS AUCTION
                </h1>
              </div>
            </div>

            {/* Vehicle Out Pass section with Gate Pass No and Date on sides */}
            <div className="border-t border-b border-gray-300 py-3 mb-3">
              <div className="flex items-center justify-between">
                {/* Gate Pass No on the left */}
                <div className="flex flex-col">
                  <div className="text-sm text-gray-600">GATE PASS NO</div>
                  <div className="text-lg font-bold text-gray-800">
                    {d.gateNo}
                  </div>
                </div>

                {/* Vehicle Out Pass in the center */}
                <div className="text-center">
                  <h2 className="text-lg font-bold text-gray-800">
                    VEHICLE OUT PASS
                  </h2>
                </div>

                {/* Date on the right */}
                <div className="text-right">
                  <div className="text-sm text-gray-600">DATE</div>
                  <div className="text-sm font-medium text-gray-800">
                    {d.issuedDate}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main: Two columns - Customer and Vehicle info */}
          <div className="px-4 py-3 grid grid-cols-2 gap-4">
            {/* First Column: Customer Information */}
            <div className="border border-gray-200 rounded p-3">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-semibold">CUSTOMER INFORMATION</h3>
                <div className="text-xs text-gray-500">CUSTOMER INFO</div>
              </div>

              <div className="grid grid-cols-3 gap-2 text-sm">
                <div className="text-gray-500">Customer Name</div>
                <div className="col-span-2 font-medium">{d.custName}</div>

                <div className="text-gray-500">Customer Email</div>
                <div className="col-span-2 font-medium">{d.custEmail}</div>

                <div className="text-gray-500">Customer Phone No</div>
                <div className="col-span-2 font-medium">{d.custPhone}</div>

                <div className="text-gray-500">Hand Over To</div>
                <div className="col-span-2 font-medium">{d.handOverTo}</div>

                <div className="text-gray-500">Recovery Name</div>
                <div className="col-span-2 font-medium">
                  {d.recoveryName || "-"}
                </div>

                <div className="text-gray-500">Recovery Phone</div>
                <div className="col-span-2 font-medium">
                  {d.recoveryPhone || "-"}
                </div>

                <div className="text-gray-500">Recovered By</div>
                <div className="col-span-2 font-medium">-</div>

                <div className="text-gray-500">Signature</div>
                <div className="col-span-2">
                  <div className="h-10 border-b border-gray-300"></div>
                </div>
              </div>
            </div>

            {/* Second Column: Vehicle Information */}
            <div className="border border-gray-200 rounded p-3">
              <h3 className="text-sm font-semibold mb-3">
                VEHICLE INFORMATION
              </h3>

              <div className="grid grid-cols-3 gap-2 text-sm">
                <div className="text-gray-500">INV NO</div>
                <div className="col-span-2 font-mono">{d.invNo}</div>

                <div className="text-gray-500">VIN NO</div>
                <div className="col-span-2 font-mono">{d.vinNo}</div>

                <div className="text-gray-500">MAKE</div>
                <div className="col-span-2 font-medium">{d.make}</div>

                <div className="text-gray-500">MODEL</div>
                <div className="col-span-2 font-medium">{d.model}</div>

                <div className="text-gray-500">YEAR</div>
                <div className="col-span-2 font-medium">{d.year}</div>

                <div className="text-gray-500">COLOR</div>
                <div className="col-span-2 font-medium">{d.color}</div>

                <div className="text-gray-500">AUCTION DATE</div>
                <div className="col-span-2 font-medium">{d.auctionDate}</div>

                <div className="text-gray-500">HAMMER PRICE</div>
                <div className="col-span-2 font-medium">{AED(d.hammer)}</div>

                <div className="text-gray-500">TOTAL AMOUNT</div>
                <div className="col-span-2 font-medium">{AED(d.total)}</div>

                <div className="text-gray-500">PAYMENT REF</div>
                <div className="col-span-2 font-medium">{d.paymentRef}</div>

                <div className="text-gray-500">SOLD STATUS</div>
                <div className="col-span-2 flex items-center gap-3">
                  <label className="flex items-center gap-2 text-sm">
                    <input
                      type="checkbox"
                      checked
                      readOnly
                      className="w-4 h-4"
                    />
                    SOLD
                  </label>
                  <label className="flex items-center gap-2 text-sm">
                    <input type="checkbox" readOnly className="w-4 h-4" />
                    RETURN
                  </label>
                </div>

                <div className="text-gray-500">PAYMENT STATUS</div>
                <div className="col-span-2 flex items-center gap-3">
                  <label className="flex items-center gap-2 text-sm">
                    <input type="checkbox" readOnly className="w-4 h-4" />
                    DUE
                  </label>
                  <label className="flex items-center gap-2 text-sm">
                    <input
                      type="checkbox"
                      checked
                      readOnly
                      className="w-4 h-4"
                    />
                    NIL
                  </label>
                  <label className="flex items-center gap-2 text-sm">
                    <input type="checkbox" readOnly className="w-4 h-4" />
                    NA
                  </label>
                </div>

                <div className="text-gray-500">PAYMENT DUE TO</div>
                <div className="col-span-2 font-medium">-</div>

                <div className="text-gray-500">RETURNED BY</div>
                <div className="col-span-2 font-medium">-</div>
              </div>
            </div>
          </div>

          {/* Contact Information & Signatures */}
          <div className="px-4 pb-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="border border-gray-200 rounded p-3 text-sm">
                <div className="font-semibold mb-2">
              Sky Auto Auction
                </div>
                <div className="text-xs text-gray-600">
                  <div>Sharjah • Dubai • +971 50 000 0000</div>
                  <div>
                    skyautotrade.aws@gmail.com | www.skyautotrade.com
                  </div>
                </div>
              </div>

              <div className="border border-gray-200 rounded p-3">
                <div className="font-semibold mb-2 text-sm">Signatures</div>
                <div className="grid grid-cols-2 gap-4 pt-4">
                  <div>
                    <div className="h-10 border-b border-gray-300"></div>
                    <p className="text-xs text-gray-500 mt-2">
                      Authorized Admin
                    </p>
                  </div>
                  <div>
                    <div className="h-10 border-b border-gray-300"></div>
                    <p className="text-xs text-gray-500 mt-2">
                      Security Officer
                    </p>
                  </div>
                </div>
                <div className="mt-3 text-xs text-gray-500">Stamp / Seal</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GatePassFromImage;
